import { render, staticRenderFns } from "./Attribute.vue?vue&type=template&id=3f3ff75e&scoped=true&lang=pug&"
import script from "./Attribute.vue?vue&type=script&lang=js&"
export * from "./Attribute.vue?vue&type=script&lang=js&"
import style0 from "./Attribute.scss?vue&type=style&index=0&id=3f3ff75e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3ff75e",
  null
  
)

export default component.exports